import { getCryptoAmountFormatter } from '../getCryptoAmountFormatter';
export const formatCryptoAmount = ({ locale, amount, symbol, }) => {
    return getCryptoAmountFormatter({ locale, symbol }).format(amount);
};
